import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import "animate.css";
import "./App.css";

// components
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import Drustvene from "./components/Drustvene";
import PremiumFloatingSocial from "./components/PremiumFloatingSocial";

// pages
import Pocetna from "./pages/Pocetna";
import PrijavaBezPl from "./pages/PrijavaBezPl";
import PrijavaSaPl from "./pages/PrijavaSaPl"; 
import Zahvala from "./pages/Zahvala";

import PaymentPage from "./pages/PaymentPage";

function App() {
  const [loading, setLoading] = useState(true);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setFade(true);
      setTimeout(() => setLoading(false), 600);
    }, 2000);
  }, []);

  if (loading) return <Loader fade={fade} />;

  return (
    <BrowserRouter>
    <PremiumFloatingSocial />
      <Nav />
    
      <Routes>
        <Route path="/" element={<Pocetna />} />
        <Route path="/prijavabezpl" element={<PrijavaBezPl />} />
        <Route path="/prijavasapl" element={<PrijavaSaPl />} />
        <Route path="/zahvala" element={<Zahvala />} />
        <Route path="/placanje" element={<PaymentPage />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;